var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "snt-loading",
    {
      staticClass: "order-contact-method",
      attrs: { loading: _vm.$apollo.loading, "min-height": "60px" },
    },
    [
      _c(
        "div",
        { staticClass: "flex items-center gap-2" },
        [
          _c("text-field-label", {
            attrs: { label: "กำหนดช่องทางจำหน่ายเอง" },
          }),
          _c(
            "div",
            [
              _vm.loading
                ? _c("v-progress-circular", {
                    attrs: { size: "16", width: "2", indeterminate: "" },
                  })
                : _c(
                    "transition",
                    { attrs: { name: "fade" } },
                    [
                      _c("v-img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.icon && !_vm.isTimeout,
                            expression: "icon && !isTimeout",
                          },
                        ],
                        staticClass: "w-4",
                        attrs: {
                          src: _vm.icon,
                          height: "16",
                          eager: "",
                          contain: "",
                        },
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("v-autocomplete", {
            attrs: {
              items: _vm.allItems,
              "search-input": _vm.searchText,
              "menu-props": {
                nudgeTop: "-4px",
                contentClass: "snt-tag-suggestions__content",
              },
              "append-icon": _vm.contactMethods.length ? "" : undefined,
              disabled: _vm.loading,
              "item-text": "description",
              "item-value": "name",
              label: "เลือกช่องทางจำหน่าย",
              placeholder: "เลือกช่องทางจำหน่าย",
              "hide-details": "",
              multiple: "",
              "hide-selected": "",
              "hide-no-data": "",
              outlined: "",
              dense: "",
              chips: "",
              solo: "",
              flat: "",
            },
            on: {
              "update:searchInput": function ($event) {
                _vm.searchText = $event
              },
              "update:search-input": function ($event) {
                _vm.searchText = $event
              },
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.addOther($event)
              },
              change: function ($event) {
                return _vm.submitDebounce($event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "selection",
                fn: function ({ attrs, select, item, index }) {
                  return [
                    _c(
                      "v-chip",
                      _vm._b(
                        {
                          staticClass: "ma-1",
                          attrs: {
                            color: "primary",
                            outlined: "",
                            label: "",
                            small: "",
                            close: "",
                          },
                          on: {
                            click: select,
                            "click:close": function ($event) {
                              return _vm.remove(index)
                            },
                          },
                        },
                        "v-chip",
                        attrs,
                        false
                      ),
                      [_vm._v(" " + _vm._s(item.description) + " ")]
                    ),
                  ]
                },
              },
              {
                key: "item",
                fn: function ({ item }) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center" },
                      [
                        _vm.$_.has(item, "image")
                          ? _c("v-img", {
                              staticClass: "mr-3 rounded",
                              attrs: {
                                width: 24,
                                height: 24,
                                src: item.image,
                                contain: "",
                              },
                            })
                          : _vm._e(),
                        _c("span", [_vm._v(_vm._s(item.description))]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.contactMethods,
              callback: function ($$v) {
                _vm.contactMethods = $$v
              },
              expression: "contactMethods",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }